'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _IssuePage = require('./IssuePage.css');

var _IssuePage2 = _interopRequireDefault(_IssuePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IssueFossilFuelFinanceInsurance = (_dec = (0, _reactCssModules2.default)(_IssuePage2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IssueFossilFuelFinanceInsurance, _Component);

  function IssueFossilFuelFinanceInsurance(props) {
    (0, _classCallCheck3.default)(this, IssueFossilFuelFinanceInsurance);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IssueFossilFuelFinanceInsurance.__proto__ || (0, _getPrototypeOf2.default)(IssueFossilFuelFinanceInsurance)).call(this, props));

    _this.state = {
      title: 'The issue: Fossil fuel finance & insurance',
      description: 'Lorem ipsum',
      url: _config2.default.domain + _config2.default.routes.issueFossilFuelFinanceInsurance
    };
    return _this;
  }

  (0, _createClass3.default)(IssueFossilFuelFinanceInsurance, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page issue-ffbi' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              'h1',
              { styleName: 'issue-top-label' },
              'The issue: ',
              _react2.default.createElement(
                'span',
                null,
                'Fossil fuel finance & insurance'
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'issue-top-headline' },
              'Financial companies are supporting fossil fuels'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'issue-top-copy' },
              'Banks and insurers that finance and underwrite fossil fuels - including tar sands, arctic drilling, and coal mining - may be hidden in your 401(k).'
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-headline' },
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap' } },
                    '\u2014\u2014\u2014\u2014'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Retirement plans are invested in climate-risk finance'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-copy' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Commercial and investment banks are lending to fossil fuel companies, despite this carbon-intensive funding being fundamentally incompatible with reaching the 1.5-degree aligned global goal necessary to prevent catastrophic climate harm.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Primary insurers and reinsurers are also continuing to underwrite and invest in coal, oil, and gas, while experiencing dramatic losses associated with catastrophic weather-related events.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'By continuing to financially support fossil fuel projects, banks and insurers are not only responsible for exacerbating climate and social impacts, but they are also exposing investors to financial risks.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement('div', { styleName: 'img-issue' })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'issue-focus-label' },
                    'FOCUS: SUSTAINABILITY RISK'
                  ),
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'issue-focus-headline' },
                    'Banks financing fossil fuels'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Since the Paris Agreement, the world\'s 60 largest banks have provided $6.9 trillion in financing to the fossil fuel industry, contributing to the climate crisis and resulting in substantial portfolio risk for investors.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      '401(k) participants deserve to understand the climate risk embedded in their portfolios from these financial institutions.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.companies + '#fossilfinance',
                          title: 'Companies: Fossil fuel finance',
                          xstrong: true
                        },
                        'Learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'section-solutions-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section section-solutions-faq' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-solutions-label' },
                      'The Solutions'
                    ),
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'issue-solutions-headline' },
                      'Offer climate-safe retirement plan options'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-copy' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'Company retirement plans should offer fund options that are sustainably invested and climate-safe, avoiding investments in fossil fuels, including climate-risk financial companies.'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.solutionOfferSustainability,
                          title: 'Solution: Offer sustainability',
                          xstrong: true
                        },
                        'Explore solutions',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-faqs-label' },
                      'FAQs'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-headline' },
                      'Answers to common questions about how retirement plans and asset managers are financing the climate crisis.'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-',
                          title: 'Do I have to sacrifice returns in order to invest sustainably?',
                          xstrong: true
                        },
                        'Do I have to sacrifice returns in order to invest sustainably?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-',
                          title: 'Why should retirement plans add a sustainable investment option?',
                          xstrong: true
                        },
                        'Why should retirement plans add a sustainable investment option?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs,
                          title: 'FAQs',
                          xstrong: true
                        },
                        'View all >>'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return IssueFossilFuelFinanceInsurance;
}(_react.Component)) || _class);
exports.default = IssueFossilFuelFinanceInsurance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/IssuePage/IssueFossilFuelFinanceInsurance.js
// module id = 1483
// module chunks = 0